import { goToSection } from '../../helpers/goToSection';
import { Sections } from '../../types/Sections';
import { Icons } from '../Icons/Icons';
import desktopArrow from '../../assets/icons/arrow-down-desktop.png';

import './NextPageBtn.scss';

type Props = {
  sectionId: Sections;
  btnText: string;
  customClassName: string;
};

export const NextPageBtn = ({
  sectionId,
  btnText,
  customClassName = '',
}: Props) => {
  return (
    <div className={`next-page-btn ${customClassName}`} id="next-page-btn">
      <button
        className="next-page-btn__text"
        onClick={() => {
          goToSection(sectionId);
        }}
      >
        {btnText}
      </button>
      <button
        onClick={() => {
          goToSection(sectionId);
        }}
        className="next-page-btn__arrow-btn"
      >
        {window.screen.width < 990 ? (
          <Icons
            name="arrow-circle"
            customClassName="next-page-btn__arrow-icon"
          />
        ) : (
          <img
            src={desktopArrow}
            alt="Next page"
            className="next-page-btn__arrow-icon"
          />
        )}
      </button>
    </div>
  );
};
